<template>
  <v-dialog
    v-model="show"
    scrollable
    :overlay="true"
    max-width="800px"
    transition="dialog-transition"
  >
    <v-card>
      <v-card-title class="body-1">
        {{ $vuetify.lang.t('$vuetify.ENFORCEMENT.INCOMES') }}
        <v-spacer></v-spacer>
        <v-btn icon small @click="show = false">
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pa-0">
        <v-form>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-data-table
                  :headers="[
                    {
                      text: $vuetify.lang.t(
                        '$vuetify.ENFORCEMENT.RECEIVED_INCOME_DATE'
                      ),
                      align: 'start',
                      sortable: false,
                      value: 'DateReceived'
                    },
                    {
                      text: $vuetify.lang.t(
                        '$vuetify.ENFORCEMENT.AMOUNT_RECEIVED'
                      ),
                      align: 'start',
                      sortable: false,
                      value: 'AmountPaid'
                    },
                    {
                      text: $vuetify.lang.t(
                        '$vuetify.ENFORCEMENT.INCOME_INSERTER'
                      ),
                      align: 'start',
                      sortable: false,
                      value: 'CreatedByOwnerName'
                    },
                    {
                      text: $vuetify.lang.t(
                        '$vuetify.ENFORCEMENT.INCOME_RECEIVED_VIA_CHANNEL'
                      ),
                      align: 'start',
                      sortable: false,
                      value: 'Type'
                    }
                  ]"
                  :items="parkingFineDebtIncomes"
                >
                  <template v-slot:item.DateReceived="props">
                    <td>{{ dateEE(props.item.DateReceived, '.', false) }}</td>
                  </template>
                  <template v-slot:item.AmountPaid="props">
                    <td>{{ `${props.item.AmountPaid}€` }}</td>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
            <v-row class="d-flex align-center">
              <v-col cols="12" sm="12">
                <v-menu
                  v-model="dateOfIncomePicker"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="
                        selectedDateOfIncome !== ''
                          ? datePickerFormat(selectedDateOfIncome)
                          : ''
                      "
                      :label="
                        $vuetify.lang.t(
                          '$vuetify.ENFORCEMENT.INCOME_RECEIVED_AT'
                        )
                      "
                      :placeholder="
                        $vuetify.lang.t(
                          '$vuetify.ENFORCEMENT.INCOME_RECEIVED_AT'
                        )
                      "
                      append-icon="mdi-calendar"
                      readonly
                      outlined
                      hide-details
                      clearable
                      v-bind="attrs"
                      @click:clear="selectedDateOfIncome = null"
                      @click:append="dateOfIncomePicker = !dateOfIncomePicker"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="selectedDateOfIncome"
                    @input="dateOfIncomePicker = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <!-- Paid amount -->
              <v-col cols="12" sm="12">
                <v-text-field
                  v-model.number="amountPaid"
                  :label="
                    `${$vuetify.lang.t(
                      '$vuetify.ENFORCEMENT.AMOUNT_RECEIVED'
                    )}*`
                  "
                  :placeholder="
                    $vuetify.lang.t('$vuetify.ENFORCEMENT.AMOUNT_RECEIVED')
                  "
                  outlined
                  hide-details
                  append-icon="mdi-cash"
                  type="number"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" class="secondary--text" text @click="save()">
          {{ $vuetify.lang.t('$vuetify.SAVE') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import formatDate from '@/mixins/formatDate'

export default {
  name: 'DebtIncomeDialog',
  mixins: [formatDate],
  props: {
    visible: {
      type: Boolean,
      required: true,
      default: false
    },
    parkingFine: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      amountPaid: 0,
      dateOfIncomePicker: false,
      selectedDateOfIncome: new Date(new Date()).toISOString().substr(0, 10),
      parkingFineDebtIncomes: []
    }
  },
  computed: {
    show: {
      get() {
        return this.visible
      },
      set(value) {
        if (!value) {
          this.$emit('close')
        }
      }
    },
    ...mapGetters('app', ['loading'])
  },
  mounted() {
    this.parkingFineDebtIncomes = []
    this.getParkingFineDebtIncomes(this.parkingFine.id).then(response => {
      this.parkingFineDebtIncomes = response
    })
  },
  methods: {
    ...mapActions('enforcement', [
      'markParkingFineIncome',
      'getParkingFineDebtIncomes'
    ]),
    save() {
      this.$confirm(this.$vuetify.lang.t('$vuetify.CAN_NOT_BE_UNDONE'), {
        title: this.$vuetify.lang.t('$vuetify.ARE_YOU_SURE'),
        color: 'error',
        icon: 'mdi-alert',
        persistent: true,
        buttonTrueText: this.$vuetify.lang.t('$vuetify.YES'),
        buttonFalseText: this.$vuetify.lang.t('$vuetify.CANCEL')
      }).then(option => {
        if (option === true) {
          this.markParkingFineIncome({
            id: this.parkingFine.id,
            amountPaid: this.amountPaid,
            dateReceived: this.selectedDateOfIncome
          })
          this.close()
        }
      })
    },
    close() {
      this.show = false
    },
    datePickerFormat(dateValue) {
      const date = new Date(dateValue)
      return `${date.getDate()}-${date.getMonth() + 1}-${date.getFullYear()}`
    }
  }
}
</script>
